import { render } from "./Main.vue?vue&type=template&id=6af69fd1&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=6af69fd1&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=6af69fd1&scope=true&lang=css"
script.render = render
script.__scopeId = "data-v-6af69fd1"

export default script